import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext(null);

export const NavigationProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState("Map");
  const [showDownloadAppModal, setShowDownloadAppModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [showRestaurantList, setShowRestaurantList] = useState(true);

  const value = {
    activeTab,
    setActiveTab,
    showDownloadAppModal,
    setShowDownloadAppModal,
    showProfileModal,
    setShowProfileModal,
    showWelcomeModal,
    setShowWelcomeModal,
    showRestaurantList,
    setShowRestaurantList,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};
